export default __webpack_public_path__ + "static/media/man-health-test.cedadc7a.svg";